import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  checkEmpanelementStatus,
  generateOnboardUrl,
} from "../../../store/actions/nps";
import { getProfileData } from "../../../store/actions/profile";

import { POP_CONFIG } from "./";

const IS_ACTIVE = 3001;
const ERROR = 99994;

const useEmpanelment = () => {
  const dispatch = useDispatch();

  const { token, userId } = useSelector(
    (globalState) => globalState.authReducer
  );

  const {
    profileData: { PAN },
  } = useSelector((globalState) => globalState.profileReducer);

  const [popDetails, setPopDetails] = useState({
    onBoardingUrl: "",
    subsequentUrl: "",
    sipUrl: "",
  });

  const [agentRef, setAgentRef] = useState("");

  useEffect(() => {
    const Arn = token.replace("ARN-", "");
    const diff = 8 - Arn.length;
    const ArnNo = "0".repeat(diff) + Arn;
    !!PAN && setAgentRef(PAN + ArnNo);
  }, [PAN, token]);

  useEffect(() => {
    const fetchAgentReferenceNumber = async () => {
      await dispatch(
        getProfileData({
          Agent: token,
          UserId: userId,
        })
      );
    };

    /**
     * Checking if the distributor is empanelled with the given pop and pop sp code
     * @param {Object} params
     * @param {string} params.AgentReferenceNumber Agent ID
     * @param {string} params.POP_Code POP Code
     * @param {string} params.POP_SP_Code POP SP Code
     * @returns {boolean}
     */

    const fetchEmpanelmentStatus = async (params) => {
      let responseCode = 99994;

      //Repeating the API Request until it returns Something other than 99994

      while (responseCode === ERROR) {
        const response = await dispatch(checkEmpanelementStatus(params));
        responseCode = parseInt(JSON.parse(response.body).Code);
      }

      return responseCode === IS_ACTIVE;
    };

    if (!!agentRef && PAN?.[3] !== "C") {
      POP_CONFIG.forEach(async (pop) => {
        const { popCode, popSpCode, subsequentUrl, sipUrl } = pop;

        const params = {
          AgentReferenceNumber: agentRef,
          POP_Code: popCode,
          POP_SP_Code: popSpCode,
        };

        const isEmpanelled = await fetchEmpanelmentStatus(params);

        if (isEmpanelled) {
          let responseCode = ERROR;
          let onBoardingUrl = "";
          while (responseCode === ERROR) {
            const response = await dispatch(generateOnboardUrl(params));
            responseCode = parseInt(JSON.parse(response.body).Code);
            const { Message } = JSON.parse(response.body);
            if (!!Message) {
              onBoardingUrl = Message;
            }
          }
          setPopDetails({
            onBoardingUrl,
            subsequentUrl,
            sipUrl: !!sipUrl ? sipUrl : "",
          });
        }
      });
    } else {
      fetchAgentReferenceNumber();
    }
  }, [PAN, dispatch, agentRef, token, userId]);

  return popDetails;
};

export default useEmpanelment;
